import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import SiteMasterLogo from "assets/SiteMaster_LOGO.png";
import NotoSans from "assets/Fonts/arial-unicode-ms.ttf";
import { getFinanceCategories } from "utils/getFinanceCategories";
Font.register({
  family: "Noto Sans",
  fonts: [
    {
      src: NotoSans,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 30,

    fontSize: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#3B0069",
    borderBottomStyle: "solid",
    paddingBottom: 10,
    marginBottom: 20,
  },
  orgName: {
    fontSize: 24,
    color: "#3B0069",
    fontWeight: "bold",
  },
  poweredBy: {
    fontSize: 8,
    color: "#666666",
    textAlign: "right",
  },
  logo: {
    width: 100,
    marginTop: 5,
  },
  reportTitle: {
    fontSize: 20,
    textAlign: "center",
    marginBottom: 20,
    color: "#3B0069",
  },
  sectionHeader: {
    backgroundColor: "#3B0069",
    color: "white",
    padding: 8,
    marginTop: 15,
    marginBottom: 10,
    borderRadius: 3,
    fontSize: 12,
    fontWeight: "bold",
  },
  table: {
    flexDirection: "column",
    marginBottom: 10,
    borderWidth: 1,
    borderColor: "#ddd",
    borderStyle: "solid",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    borderBottomStyle: "solid",
    fontFamily: "Noto Sans",
  },
  tableCell: {
    flex: 1,
    padding: 8,
    fontSize: 9,
    borderRightWidth: 1,
    borderRightColor: "#ddd",
    borderRightStyle: "solid",
  },
  tableHeaderCell: {
    flex: 1,
    padding: 8,
    fontSize: 9,
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
    color: "#3B0069",
    borderRightWidth: 1,
    borderRightColor: "#ddd",
    borderRightStyle: "solid",
  },
  lastCell: {
    borderRightWidth: 0,
  },
  noData: {
    textAlign: "center",
    color: "#666",
    fontStyle: "italic",
    padding: 8,
  },
  summaryBox: {
    padding: 10,
    backgroundColor: "#f9f9fa",
    borderRadius: 5,
    marginBottom: 10,
    borderLeftWidth: 2,
    borderLeftColor: "#3B0069",
    borderLeftStyle: "solid",
  },
  summaryBoxHeader: {
    fontWeight: "bold",
    marginBottom: 5,
    fontSize: 11,
    color: "#3B0069",
  },
  detailRow: {
    flexDirection: "row",
    marginBottom: 3,
  },
  detailLabel: {
    fontWeight: "bold",
    width: "30%",
  },
  detailValue: {
    width: "70%",
  },
  taskSection: {
    marginBottom: 15,
    padding: 10,
    borderRadius: 5,
    backgroundColor: "#fefefe",
    borderWidth: 1,
    borderColor: "#ddd",
    borderStyle: "solid",
  },
  taskHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  taskTitle: {
    fontSize: 14,
    color: "#3B0069",
    fontWeight: "bold",
    marginRight: 10,
  },
  taskStatus: {
    fontSize: 10,
    padding: 2,
    borderRadius: 3,
  },
  statusCompleted: {
    backgroundColor: "#e6f7ee",
    color: "#069132",
    borderWidth: 1,
    borderColor: "#b7ebc6",
  },
  statusOngoing: {
    backgroundColor: "#e6f0ff",
    color: "#0052cc",
    borderWidth: 1,
    borderColor: "#b3d4ff",
  },
  statusPending: {
    backgroundColor: "#fff8e6",
    color: "#e6a700",
    borderWidth: 1,
    borderColor: "#ffe2a8",
  },
  subtaskHeader: {
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
    padding: 8,
    fontSize: 11,
    color: "#3B0069",
    borderTopWidth: 1,
    borderTopColor: "#ddd",
    borderTopStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    borderBottomStyle: "solid",
    marginTop: 10,
  },
  photosContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    marginTop: 5,
  },
  photoWrapper: {
    width: "48%",
    marginBottom: 10,
    marginRight: "2%",
    borderWidth: 1,
    borderColor: "#ddd",
    borderStyle: "solid",
    padding: 5,
  },
  sitePhoto: {
    width: "100%",
    height: 120,
    objectFit: "contain",
  },
  photoCaption: {
    fontSize: 8,
    textAlign: "center",
    marginTop: 3,
    color: "#666",
  },
  dateRangeText: {
    fontSize: 10,
    color: "#666",
    marginBottom: 8,
    marginTop: 2,
    fontStyle: "italic",
  },
  updateContainer: {
    marginTop: 5,
    paddingLeft: 10,
    borderLeftWidth: 1,
    borderLeftColor: "#eee",
    borderLeftStyle: "solid",
  },
  updateItem: {
    marginBottom: 8,
    padding: 5,
    backgroundColor: "#fcfcfc",
    borderRadius: 3,
  },
  updateComment: {
    fontSize: 9,
    color: "#333",
    marginBottom: 2,
  },
  updateMeta: {
    fontSize: 7,
    color: "#888",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  approvalBadge: {
    fontSize: 8,
    padding: 2,
    borderRadius: 2,
    marginTop: 3,
    alignSelf: "flex-start",
  },
  statusApproved: {
    backgroundColor: "#e6f7ee",
    color: "#069132",
  },
  statusRejected: {
    backgroundColor: "#fff1f0",
    color: "#f5222d",
  },
  updateImage: {
    width: 100,
    height: 100,
    marginTop: 5,
    borderRadius: 3,
    objectFit: "cover",
  },

  // --- Modernized Tasks UI (2026-style cards) ---
  taskGroupCard: {
    padding: 12,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: "#E6E8EF",
    borderStyle: "solid",
  },
  taskGroupHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 8,
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#EEF0F6",
    borderBottomStyle: "solid",
  },
  taskGroupTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#111827",
  },
  countBadge: {
    backgroundColor: "#F3F4F6",
    color: "#374151",
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 999,
    fontSize: 9,
    fontWeight: "bold",
  },
  taskCard: {
    padding: 10,
    backgroundColor: "#FBFCFF",
    borderRadius: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: "#EEF0F6",
    borderStyle: "solid",
  },
  taskCardHeaderRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  taskTitleText: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#111827",
    flexGrow: 2,
    flexShrink: 1,
    marginRight: 8,
  },
  taskHeaderMetaBlock: {
    flexGrow: 1,
    flexShrink: 1,
    marginRight: 8,
  },
  taskHeaderMetaText: {
    fontSize: 8,
    color: "#4B5563",
    lineHeight: 1.2,
  },
  taskHeaderMetaLabel: {
    color: "#6B7280",
  },
  statusPill: {
    fontSize: 9,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 999,
    fontWeight: "bold",
  },
  metaRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  metaItem: {
    width: "49%",
  },
  metaLabel: {
    fontSize: 8,
    color: "#6B7280",
    marginBottom: 2,
  },
  metaValue: {
    fontSize: 9,
    color: "#111827",
  },
  divider: {
    height: 1,
    backgroundColor: "#EEF0F6",
    marginTop: 10,
    marginBottom: 10,
  },
  subSectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#374151",
    marginBottom: 8,
  },
  subtaskCard: {
    padding: 9,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#EEF0F6",
    borderStyle: "solid",
    marginBottom: 8,
  },
  subtaskHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 6,
  },
  subtaskTitleText: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#111827",
    flexGrow: 1,
    flexShrink: 1,
    marginRight: 8,
  },
  subtaskTimelineText: {
    fontSize: 8,
    color: "#4B5563",
    flexShrink: 1,
    marginRight: 8,
    lineHeight: 1.2,
  },
  subtaskMetaLine: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  subtaskMetaText: {
    fontSize: 8,
    color: "#4B5563",
  },
  updatesBlock: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: "#EEF0F6",
    borderTopStyle: "solid",
  },
  updatesTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#374151",
    marginBottom: 6,
  },
  updateItemModern: {
    padding: 8,
    backgroundColor: "#F9FAFB",
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#EEF0F6",
    borderStyle: "solid",
    marginBottom: 6,
  },
  updateItemModernCompact: {
    // Keep text-only updates consistently small
    maxHeight: 72,
    overflow: "hidden",
  },
  updateMetaModern: {
    marginTop: 3,
    fontSize: 8,
    color: "#6B7280",
    lineHeight: 1.2,
  },
});

const TableRow = ({ cells, header }) => (
  <View style={styles.tableRow}>
    {cells.map((cell, idx) => (
      <Text
        key={idx}
        style={[
          header ? styles.tableHeaderCell : styles.tableCell,
          idx === cells.length - 1 && styles.lastCell,
        ]}
      >
        {cell}
      </Text>
    ))}
  </View>
);

const PDFReport = ({ data: responseData, dateRange, selectedSections }) => {
  const data = responseData?.data || {};
  // console.log("SITE UPDATES", data.site_updates);
  console.log("PAYMENT DATA", data.payments);
  const siteData = JSON.parse(localStorage.getItem("siteData") || "{}");
  const organization = JSON.parse(localStorage.getItem("organization") || "{}");
  // const categoryData = getFinanceCategories();
  const refundCategory = JSON.parse(localStorage.getItem("refundCategory") || "null");
  const receivedCategory = JSON.parse(localStorage.getItem("receivedCategory") || "null");
  const formatCurrency = (amount) => {
    return `Rs ${parseFloat(amount).toFixed(2)}`;
  };

  const formatDate = (date) => {
    try {
      return new Date(date).toLocaleDateString();
    } catch (error) {
      return "Invalid Date";
    }
  };

const getStatusStyle = (status) => {
  if (status === "Complete" || status === "Completed") return styles.statusCompleted;
  if (status === "Ongoing") return styles.statusOngoing;
  if (status === "Not started") return styles.statusPending;
  return styles.statusPending; // Default for unknown statuses
};

  // Helper function to format date range
  const formatDateRange = () => {
    if (dateRange?.start_date && dateRange?.end_date) {
      return `Date Range: ${formatDate(dateRange.start_date)} - ${formatDate(
        dateRange.end_date
      )}`;
    } else if (dateRange?.start_date) {
      return `From: ${formatDate(dateRange.start_date)}`;
    } else if (dateRange?.end_date) {
      return `Until: ${formatDate(dateRange.end_date)}`;
    }
    return "Date Range: All dates";
  };

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.orgName}>
            {organization?.organization_name || "Organization"}
          </Text>
          <View style={styles.poweredBy}>
            <Text>Powered by</Text>
            <Image style={styles.logo} src={SiteMasterLogo} />
          </View>
        </View>

        <Text style={styles.reportTitle}>Project Site Report</Text>

        <View style={styles.summaryBox}>
          <Text>
            <Text style={{ fontWeight: "bold" }}>Site Name: </Text>
            {siteData?.site_name || "N/A"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>Address: </Text>
            {siteData?.address || "N/A"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>City: </Text>
            {siteData?.city || "N/A"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>State: </Text>
            {siteData?.state || "N/A"} - {siteData?.pincode || "N/A"}
          </Text>
        </View>

        {selectedSections?.site_updates && (
          <View>
            <Text style={styles.sectionHeader}>General Updates</Text>
            <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
            {Object.keys(data.site_updates || {}).length > 0 ? (
              Object.entries(data.site_updates).map(([date, updates], idx) => (
                <View key={idx} style={styles.summaryBox}>
                  <Text style={styles.summaryBoxHeader}>Date: {date}</Text>
                  <View style={styles.table}>
                    <TableRow cells={["Time", "Comment", "Posted By"]} header />
                    {updates.map((update, id) => (
                      <View key={id}>
                        <TableRow
                          cells={[
                            new Date(update.createdAt).toLocaleTimeString(),
                            update.comment,
                            update.senderName,
                          ]}
                        />
                        {update.media.length > 0 && (
                          <View style={styles.photosContainer}>
                            {update.media.map((media) => (
                              <View
                                key={media.mediaId}
                                style={styles.photoWrapper}
                              >
                                <Image
                                  style={styles.sitePhoto}
                                  src={{
                                    uri:
                                      media.url ||
                                      "https://cdn-icons-png.flaticon.com/512/13434/13434972.png",
                                  }}
                                  alt="Site Update"
                                />
                                <Text style={styles.photoCaption}>
                                  {media.caption || "No caption"}
                                </Text>
                              </View>
                            ))}
                          </View>
                        )}
                      </View>
                    ))}
                  </View>
                </View>
              ))
            ) : (
              <View style={styles.summaryBox}>
                <Text style={styles.noData}>
                  No site updates found for the selected date range
                </Text>
              </View>
            )}
          </View>
        )}

        {selectedSections?.payments && data.payments?.length > 0 && (
          <View>
            <Text style={styles.sectionHeader}>Payments</Text>
            <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
            <View style={styles.table}>
              <TableRow
                cells={[
                  "Amount",
                  "Date",
                  "Method",
                  "Type",
                  "Comments",
                  "Credit/Debit",
                ]}
                header
              />
              {data.payments.map((payment, idx) => (
                <TableRow
                  key={idx}
                  cells={[
                    formatCurrency(payment.amount),
                    payment.transaction_date || "N/A",
                    payment.transaction_method || "N/A",
                    payment.transaction_type || payment.payment_type || "N/A",
                    payment.comments || "-",
                    payment.transaction_catagory_id === refundCategory ||
                    payment.transaction_catagory_id === receivedCategory
                      ? "Credit"
                      : "Debit",
                  ]}
                />
              ))}
            </View>
          </View>
        )}

        {selectedSections?.attendance && data.attendance && (
          <View>
            <Text style={styles.sectionHeader}>Attendance</Text>
            <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
            {Object.entries(data.attendance)
              .filter(([date, att]) => att.total_present > 0)
              .map(([date, att], idx) => (
                <View key={idx} style={styles.summaryBox}>
                  <Text style={styles.summaryBoxHeader}>Date: {date}</Text>
                  <View style={styles.table}>
                    <TableRow
                      cells={[
                        "Total Present",
                        "Worker Present",
                        "Worker Absent",
                      ]}
                      header
                    />
                    <TableRow
                      cells={[
                        att.total_present?.toString() || "0",
                        att.worker_present?.toString() || "0",
                        att.worker_absent?.toString() || "0",
                      ]}
                    />
                  </View>
                  {att.data?.length > 0 && (
                    <View style={styles.table}>
                      <TableRow
                        cells={["Worker Name", "Work Type", "Attendance"]}
                        header
                      />
                      {att.data.map((record, id) => (
                        <TableRow
                          key={id}
                          cells={[
                            record.worker_name || "N/A",
                            record.worker_workname || "N/A",
                            record.attendance || "N/A",
                          ]}
                        />
                      ))}
                    </View>
                  )}
                </View>
              ))}
          </View>
        )}

        {selectedSections?.material_inventory && data.material_inventory && (
          <View>
            <Text style={styles.sectionHeader}>Material Inventory</Text>
            <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
            {Object.entries(data.material_inventory).map(
              ([category, items], idx) => (
                <View key={idx} style={styles.summaryBox}>
                  <Text style={styles.summaryBoxHeader}>{category}</Text>
                  {items?.length > 0 ? (
                    <View style={styles.table}>
                      <TableRow
                        cells={[
                          "Current Quantity",
                          "Update Date",
                          "Entered Quantity",
                          "Comment",
                        ]}
                        header
                      />
                      {items.map((item, id) => (
                        <TableRow
                          key={id}
                          cells={[
                            item.current_quantity?.toString() || "0",
                            item.update_date || "N/A",
                            item.entered_quantity?.toString() || "0",
                            item.comment || "-",
                          ]}
                        />
                      ))}
                    </View>
                  ) : (
                    <Text style={styles.noData}>No inventory data</Text>
                  )}
                </View>
              )
            )}
          </View>
        )}

        {selectedSections?.material_deliveries &&
          data.material_deliveries?.length > 0 && (
            <View>
              <Text style={styles.sectionHeader}>Material Deliveries</Text>
              <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
              {data.material_deliveries.map((delivery, idx) => (
                <View key={idx} style={styles.summaryBox}>
                  <Text style={styles.summaryBoxHeader}>
                    Delivery on {delivery.date || "N/A"} -{" "}
                    {formatCurrency(delivery.total_price)}
                  </Text>
                  <Text>
                    <Text style={{ fontWeight: "bold" }}>Vendor: </Text>
                    {delivery.vendor_name || "N/A"} (
                    {delivery.contact_no || "N/A"})
                  </Text>
                  <Text>
                    <Text style={{ fontWeight: "bold" }}>Payment Status: </Text>
                    {delivery.payment_status || "N/A"} (
                    {delivery.payment_method || "N/A"}) – Paid:{" "}
                    {formatCurrency(delivery.paid_amount)}
                    {delivery.remaining_payment > 0 &&
                      `, Remaining: ${formatCurrency(
                        delivery.remaining_payment
                      )}`}
                  </Text>
                  {delivery.all_materials?.length > 0 && (
                    <View style={styles.table}>
                      <TableRow
                        cells={[
                          "Material",
                          "Quantity",
                          "Unit Price",
                          "Total Price",
                        ]}
                        header
                      />
                      {delivery.all_materials.map((material, id) => (
                        <TableRow
                          key={id}
                          cells={[
                            `${material.material_name || "N/A"} (${
                              material.material_subcategory || "N/A"
                            })`,
                            `${material.quantity || 0} ${material.unit || ""}`,
                            formatCurrency(material.unit_price),
                            formatCurrency(material.total_price),
                          ]}
                        />
                      ))}
                    </View>
                  )}
                  {delivery.remarks && (
                    <Text>
                      <Text style={{ fontWeight: "bold" }}>Remarks: </Text>
                      {delivery.remarks}
                    </Text>
                  )}
                </View>
              ))}
            </View>
          )}

        {/* {selectedSections?.tasks && data.tasks?.length > 0 && (
          <View>
            <Text style={styles.sectionHeader}>Tasks</Text>
            <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
            {data.tasks.map((task, idx) => (
              <View key={idx} style={styles.taskSection}>
                <View style={styles.taskHeader}>
                  <Text style={styles.taskTitle}>
                    {task.task_name || "Unnamed Task"}
                  </Text>
                  <Text
                    style={[
                      styles.taskStatus,
                      getStatusStyle(task.task_status),
                    ]}
                  >
                    {task.task_status || "Unknown"}
                  </Text>
                </View>
                <View style={styles.detailRow}>
                  <Text style={styles.detailLabel}>Details: </Text>
                  <Text style={styles.detailValue}>
                    {task.task_details || "No details"}
                  </Text>
                </View>
                <View style={styles.detailRow}>
                  <Text style={styles.detailLabel}>Priority: </Text>
                  <Text style={styles.detailValue}>
                    {task.priority || "N/A"}
                  </Text>
                </View>
                <View style={styles.detailRow}>
                  <Text style={styles.detailLabel}>Timeline: </Text>
                  <Text style={styles.detailValue}>
                    {task.start_date || "N/A"} to {task.end_date || "N/A"}
                  </Text>
                </View>
                <View style={styles.detailRow}>
                  <Text style={styles.detailLabel}>Estimated Amount: </Text>
                  <Text style={styles.detailValue}>
                    {formatCurrency(task.estimated_amount)}
                  </Text>
                </View>

                {task.task_materials?.length > 0 && (
                  <View>
                    <Text style={styles.subtaskHeader}>Materials Required</Text>
                    <View style={styles.table}>
                      <TableRow
                        cells={["Material", "Estimated Qty", "Used Qty", "UOM"]}
                        header
                      />
                      {task.task_materials.map((material, id) => (
                        <TableRow
                          key={id}
                          cells={[
                            `${material.material_name || "N/A"} (${
                              material.subcategory || "N/A"
                            })`,
                            material.estimated_quantity?.toString() || "0",
                            material.total_used?.toString() || "0",
                            material.uom || "N/A",
                          ]}
                        />
                      ))}
                    </View>
                  </View>
                )}

                {task.subtasks?.length > 0 && (
                  <View>
                    <Text style={styles.subtaskHeader}>Subtasks</Text>
                    <View style={styles.table}>
                      <TableRow
                        cells={["Name", "Status", "Timeline", "Assigned To"]}
                        header
                      />
                      {task.subtasks.map((subtask, id) => (
                        <TableRow
                          key={id}
                          cells={[
                            subtask.subtask_name || "Unnamed Subtask",
                            subtask.is_completed ? "Completed" : "Pending",
                            `${subtask.start_date || "N/A"} to ${
                              subtask.end_date || "N/A"
                            }`,
                            subtask.assign_to || "Unassigned",
                          ]}
                        />
                      ))}
                    </View>
                  </View>
                )}

                {task.task_members?.length > 0 && (
                  <Text>
                    <Text style={{ fontWeight: "bold" }}>Team Members: </Text>
                    {task.task_members.length} assigned
                  </Text>
                )}
              </View>
            ))}
          </View>
        )} */}
        {selectedSections?.tasks && data.tasks?.task_groups?.length > 0 && (
          <View>
            <Text style={styles.sectionHeader}>Tasks</Text>
            <Text style={styles.dateRangeText}>{formatDateRange()}</Text>
            {data.tasks.task_groups.map((taskGroup, groupIdx) => (
              <View key={groupIdx} style={styles.taskGroupCard}>
                <View style={styles.taskGroupHeaderRow}>
                  <Text style={styles.taskGroupTitle}>
                    {taskGroup.task_group_name || "Task Group"}
                  </Text>
                  <Text style={styles.countBadge}>
                    {(taskGroup.total_tasks ?? taskGroup.tasks?.length ?? 0).toString()}{" "}
                    tasks
                  </Text>
                </View>

                {taskGroup.tasks?.length > 0 ? (
                  taskGroup.tasks.map((task, taskIdx) => (
                  <View key={taskIdx} style={styles.taskCard}>
                    <View style={styles.taskCardHeaderRow}>
                      <Text style={styles.taskTitleText}>
                        {task.task_name || "Unnamed Task"}
                      </Text>
                      <View style={styles.taskHeaderMetaBlock}>
                        <Text style={styles.taskHeaderMetaText} maxLines={1}>
                          <Text style={styles.taskHeaderMetaLabel}>Timeline: </Text>
                          {formatDate(task.start_date)} – {formatDate(task.end_date)}
                        </Text>
                        <Text style={styles.taskHeaderMetaText} maxLines={1}>
                          <Text style={styles.taskHeaderMetaLabel}>Assignees: </Text>
                          {task.assignees?.length > 0
                            ? `${task.assignees.length} member${
                                task.assignees.length === 1 ? "" : "s"
                              }`
                            : "Unassigned"}
                        </Text>
                      </View>
                      <Text style={[styles.statusPill, getStatusStyle(task.status)]}>
                        {(task.status || "Unknown").toString()}
                      </Text>
                    </View>
                    {task.subtasks?.length > 0 && (
                      <View>
                        <View style={styles.divider} />
                        <Text style={styles.subSectionTitle}>
                          Subtasks ({task.subtasks.length})
                        </Text>

                        {task.subtasks.map((subtask, subtaskIdx) => {
                          const subtaskStatusText = subtask.completed
                            ? "Completed"
                            : "Pending";

                          return (
                            <View key={subtaskIdx} style={styles.subtaskCard}>
                              <View style={styles.subtaskHeaderRow}>
                                <Text style={styles.subtaskTitleText}>
                                  {subtask.subtask_name || "Unnamed Subtask"}
                                </Text>
                                <Text style={styles.subtaskTimelineText} maxLines={1}>
                                  {formatDate(subtask.start_date)} – {formatDate(subtask.end_date)}
                                </Text>
                                <Text
                                  style={[
                                    styles.statusPill,
                                    getStatusStyle(subtaskStatusText),
                                  ]}
                                >
                                  {subtaskStatusText}
                                </Text>
                              </View>

                              <View style={styles.subtaskMetaLine}>
                                <Text style={styles.subtaskMetaText}>
                                  {subtask.assignees?.length > 0
                                    ? `${subtask.assignees.length} assigned`
                                    : "Unassigned"}
                                </Text>
                              </View>

                              {subtask.updates?.length > 0 && (
                                <View style={styles.updatesBlock}>
                                  <Text style={styles.updatesTitle}>
                                    Updates ({subtask.updates.length})
                                  </Text>
                                  {subtask.updates.map((update, updateIdx) => (
                                    <View
                                      key={updateIdx}
                                      style={[
                                        styles.updateItemModern,
                                        !(
                                          update?.file && String(update.file).trim()
                                        ) && styles.updateItemModernCompact,
                                      ]}
                                    >
                                      {(() => {
                                        const hasImage = Boolean(
                                          update?.file && String(update.file).trim()
                                        );
                                        const cleanInlineText = (value, fallback) => {
                                          const s = String(value ?? "");
                                          const withoutZeroWidth = s.replace(
                                            /[\u200B-\u200D\uFEFF]/g,
                                            ""
                                          );
                                          const collapsed = withoutZeroWidth
                                            .replace(/\s+/g, " ")
                                            .trim();
                                          return collapsed || fallback;
                                        };

                                        const comment = cleanInlineText(
                                          update?.comment,
                                          "-"
                                        );
                                        const createdBy = cleanInlineText(
                                          update?.created_by,
                                          "N/A"
                                        );
                                        const dateText = formatDate(update?.date);

                                        return (
                                          <>
                                            <Text
                                              style={styles.updateComment}
                                              maxLines={hasImage ? 3 : 2}
                                            >
                                              {comment}
                                            </Text>
                                            <Text style={styles.updateMetaModern} maxLines={1}>
                                              By {createdBy} • {dateText}
                                            </Text>

                                            {update.is_request_for_approval && (
                                              <View
                                                style={[
                                                  styles.approvalBadge,
                                                  update.approval_status === "approved"
                                                    ? styles.statusApproved
                                                    : update.approval_status === "rejected"
                                                    ? styles.statusRejected
                                                    : styles.statusPending,
                                                ]}
                                              >
                                                <Text>
                                                  {update.approval_status
                                                    ? `Approval: ${String(
                                                        update.approval_status
                                                      )
                                                        .trim()
                                                        .toUpperCase()}`
                                                    : "Approval: PENDING"}
                                                  {update.approved_by
                                                    ? ` by ${cleanInlineText(
                                                        update.approved_by,
                                                        ""
                                                      )}`
                                                    : ""}
                                                </Text>
                                              </View>
                                            )}

                                            {hasImage && (
                                              <Image
                                                style={styles.updateImage}
                                                src={{ uri: String(update.file).trim() }}
                                              />
                                            )}
                                          </>
                                        );
                                      })()}
                                    </View>
                                  ))}
                                </View>
                              )}
                            </View>
                          );
                        })}
                      </View>
                    )}
                  </View>
                  ))
                ) : (
                  <Text style={styles.noData}>No tasks in this group</Text>
                )}
              </View>
            ))}
          </View>
        )}
      </Page>
    </Document>
  );
};

export default PDFReport;
